
import { defineComponent, PropType, ref, watch } from "vue";
import Multiselect from "@vueform/multiselect";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronDown, mdiClose, mdiLoading  } from "@mdi/js";

export default defineComponent({
  components: {
    Multiselect,
    SvgIcon,
  },
  setup() {
    const multiselect = ref<InstanceType<any> | null>(null);

    const clear = () => {
      multiselect.value?.clear();
    };
    const removeTag = (option:any)=>{
    multiselect.value?.remove(option)
    }

    return {
      clear,
      multiselect,
      removeTag,
      caretIcon: mdiChevronDown,
      clearIcon: mdiClose,
      loadingIcon: mdiLoading,
    };
  },
});
